exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal__content[data-v-ae1900f0] {\n  padding: 20px 20px 20px 50px;\n}\n.modal__content .cases-title[data-v-ae1900f0] {\n    font-size: 22px;\n}\n.modal__content ul[data-v-ae1900f0] {\n    padding: 0;\n}\n.modal__header[data-v-ae1900f0] {\n  font-family: Arial,Tahoma,sans-serif;\n  font-weight: 100;\n  font-size: 24px;\n  line-height: 24px;\n}\n.modal__footer[data-v-ae1900f0] {\n  width: 30%;\n  float: left;\n  display: flex;\n  justify-content: flex-start;\n}\n", ""]);

// exports
